/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate your Body Mass Index`)
};

const es_bmi_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula tu Índice de Masa Corporal`)
};

const de_bmi_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnen Sie Ihren Body-Mass-Index`)
};

const nl_bmi_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken uw Body Mass Index`)
};

const fr_bmi_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez votre indice de masse corporelle`)
};

const it_bmi_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola il tuo Indice di Massa Corporea`)
};

const pt_br2_bmi_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule seu Índice de Massa Corporal`)
};

const pt_bmi_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule o seu Índice de Massa Corporal`)
};

const ja_bmi_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体格指数を計算する`)
};

const zh_bmi_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算您的身体质量指数`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_nav_main_desc", locale)
	if (locale === "en") return en_bmi_nav_main_desc(inputs)
	if (locale === "es") return es_bmi_nav_main_desc(inputs)
	if (locale === "de") return de_bmi_nav_main_desc(inputs)
	if (locale === "nl") return nl_bmi_nav_main_desc(inputs)
	if (locale === "fr") return fr_bmi_nav_main_desc(inputs)
	if (locale === "it") return it_bmi_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_nav_main_desc(inputs)
	if (locale === "pt") return pt_bmi_nav_main_desc(inputs)
	if (locale === "ja") return ja_bmi_nav_main_desc(inputs)
	return zh_bmi_nav_main_desc(inputs)
};